<template>
  <div>
    <div class="details" v-if="product">
      <div class="return" @click="$router.go(-1)">X</div>
      <div class="display">
        <buy-one-get-one
          v-if="product.BuyAGetB_promotion"
          v-bind:fromQty="product.BuyAGetB_FromQty"
          v-bind:relatedQty="product.BuyAGetB_RelatedQty"
        ></buy-one-get-one>
        <div class="productsingleli">
          <div class="ps_left">
            <div class="product-single__photo-wrapper">
              <img v-if="product.Images[0]" class="desktop-image" :src="bigImg || product.Images[0]" alt=""
                   @click="toggleImgModalVisibility(true, zoomImg ? zoomImg : product.Large_Images[0])">
              <img class="desktop-image" v-else :src="require('@/assets/img/defaultImg.png')" alt="">
              <div class="favorite-button" v-if="loggedIn" @click="favoriteProduct(product)">
                <font-awesome-icon v-if="!favorited" icon="heart" class="like-btn"
                                   :style="{ color: 'rgba(191, 191, 191, 0.5)', fontSize: '15px',  }"/>
                <font-awesome-icon v-if="favorited" icon="heart" class="like-btn"
                                   :style="{ color: 'rgb(224, 36, 94)', fontSize: '15px',  }"/>
              </div>
            </div>
          </div>
          <div class="ps_right" v-if="product.Images && product.Images.length>1">
            <div class="thumbnails-wrapper">
              <ul>
                <li v-for="(item,index) in product.Images" :class="isactive == index?'isactive':''" :key="index">
                  <a href="javascript:void(0)" @click="tabImg(index)"><img :src="item" alt=""></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="product-single__meta">
          <h1 class="product-single__title" v-if='$i18n.locale=="en"'>{{ product.Name }}</h1>
          <h1 class="product-single__title" v-if='$i18n.locale=="ch"'>{{ product.Description }}</h1>
          <p v-if='$i18n.locale=="en"' class="product-single__brand" @click="onClickBrand(product.Brand)">
            {{ product.English_Details_Brand }}</p>
          <p v-if='$i18n.locale=="ch"' class="product-single__brand" @click="onClickBrand(product.Brand)">
            {{ product.Chinese_Details_Brand }}</p>
          <!-- <div class="price-marge">
            <div :class="['product__price', (product.IsPromotion || product.BuyAGetB_promotion) ? 'promo' : '']"><span>${{ product.Price.toFixed(2) }}</span>
            </div>
            <div class="price_original_detail_page" v-show="product.IsPromotion"><span>${{ product.OriginalPrice }}</span>
            </div>
          </div> -->
          <div class="pro_row_detail">
            <span v-if="loggedIn && showInstock && !this.isOutOfStock(product)" class="pro_tt_dt">{{$t('stock')}}: {{product.InventoryQuantity ? product.InventoryQuantity : 0}}</span>
            <span v-if="loggedIn && showInstock && this.isOutOfStock(product)" class="pro_tt_red_dt">{{$t('outOfStock')}}</span>
            <span></span>  
            <span v-show="product && product.Price || false" v-if="loggedIn && showPrice" class="pro_tt_price_dt">${{product ? product.Price.toFixed(2) : ''}}</span>
          </div>
          <div class="pro_tt_dt" v-if="product.RefNum && product.RefNum != ''">{{product.RefNum}}</div>
          <span v-if="loggedIn" class="pro_tt_dt">{{product.LotNum}}</span>
          <div class="product_reviews_below_title">
            <div class="qty_and_cart">
              <div class="review-container">
                <div class="star-img-container">
                  <img v-for="(item,index) in starIndex" :data-index="index" :key="index" class="star-img" :src="item"
                       alt="">
                  <p class="star-text">{{ this.starRating }}</p>
                </div>
              </div>
              <!-- <div class="quantity-box">
                <button class="quantity-button" @click="updateItemCount($event, product)">-</button>
                <p class="curr-quantity">{{ this.currQuantity }}</p>
                <button @click="addToCart(product)" class="quantity-button">+</button>
              </div> -->
            </div>
            <div v-if="product.IsProposition65" class="warning">
              <img src="../../assets/img/warning.png" alt="">
              <span>
              For more information:
              <a class="warning-link" href="https://www.p65warnings.ca.gov/">www.P65Warnings.ca.gov</a>
            </span>
            </div>
          </div>
        </div>
      </div>
      <div class="details-page-width">
        <div class="product-single__description rte">
          <!-- <h2 class="section-header__title">Details</h2> -->
          <template></template>
          <!-- <div class="new-detail-container">
            <div class="new-detail-table">
              <div class="new-detail-line odd">
                <p class="detail-title">{{ $t('brand') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Brand }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Brand }}</p>
              </div>
              <div class="new-detail-line even">
                <p class="detail-title">{{ $t('brandOrigin') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Brand_Origin }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Brand_Origin }}</p>
              </div>
              <div class="new-detail-line odd">
                <p class="detail-title">{{ $t('netContent') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_NetContent }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_NetContent }}</p>
              </div>
              <div class="new-detail-line even">
                <p class="detail-title">{{ $t('madeIn') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Made_In }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Made_In }}</p>
              </div>
              <div class="new-detail-line odd">
                <p class="detail-title">{{ $t('ingredients') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Ingredients }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Ingredients }}</p>
              </div>
              <div class="new-detail-line even">
                <p class="detail-title">{{ $t('organic') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Organic }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Organic }}</p>
              </div>
              <div class="new-detail-line odd">
                <p class="detail-title">{{ $t('containsSugar') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Contains_Sugar }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Contains_Sugar }}</p>
              </div>
              <div class="new-detail-line even">
                <p class="detail-title">{{ $t('flavor') }}</p>
                <p v-if="$i18n.locale == 'en'" class="detail-desc">{{ product.English_Details_Flavor }}</p>
                <p v-if="$i18n.locale == 'ch'" class="detail-desc">{{ product.Chinese_Details_Flavor }}</p>
              </div>
            </div>
          </div> -->
          <div class="rich-text-container">
            <p class="rich-text" v-if="product.rich_text_description">
              <span v-html="product.rich_text_description"></span>
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="mobile_add_container">
        <div class="mobile_footer"> -->
          <!-- <button class="icon-button">
            <font-awesome-icon
              icon="shopping-cart"
              :style="{ color: 'white', fontSize: '22px' }"
              class="icon-shadow"
              v-if="currQuantity === 0"/>
            <p v-else>{{ this.currQuantity }}</p>
          </button> -->
        <!-- </div> -->
        <!--add to cart btn-->
          <!-- <button v-if="product.InventoryQuantity>0" class="add_cart" @click="addToCart(product)">{{ $t('add_to_cart') }}</button>
          <button v-else class="out_stock">{{ $t('soldOut') }}</button> -->
        <!--end add to cart btn -->
      <!-- </div> -->
      <div class="home-footer">
        <div class="icon-col" style="borderRight: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../../assets/img/headset.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('customer_service_nocaps') }}</h2>
            <p>{{ $t('call_chat_visit') }}</p>
          </div>
        </div>
        <div class="icon-col">
          <div class="homeFooter-img">
            <img src="../../assets/img/truckHome.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('free_shipping') }}</h2>
            <p>{{ $t('get_shopafm_free') }}</p>
          </div>
        </div>
        <div class="icon-col" style="borderLeft: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../../assets/img/onlinePayment.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('online_payment') }}</h2>
            <p>{{ $t('we_accept_all') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <img style="display: block; margin: 0 auto" src="../../assets/img/loading.gif" alt="">
    </div>
  </div>
</template>
<script type="text/javascript">
Vue.use(VueHZoom);
</script>
<script>
import VueHZoom from 'vue-h-zoom';
import {fasShoppingCart} from '@fortawesome/fontawesome-svg-core';
import VueSocialSharing from "vue-social-sharing";

import {mapActions, mapMutations, mapState} from 'vuex';
import Router from 'vue-router';
import Vue from 'vue';
import smoothproducts from '../../assets/js/smoothproducts.min';
import breadcrumb from '../../components/breadcrumb'
import star0 from '../../assets/img/star0.jpg'
import star1 from '../../assets/img/star1.jpg'
import star2 from '../../assets/img/star2.jpg'
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../../store/modules/cart";
import productCard from "../productCard";
import fbicon from "../../assets/img/facebook_icon.png";
import twittericon from "../../assets/img/twitter_icon.png";
import pinteresticon from "../../assets/img/pinterest_icon.png";
import whatsappicon from "../../assets/img/whatsapp_icon.png";
import lineicon from "../../assets/img/line_icon.png";
import {toProductDetail} from "../../mixin";
import buyOneGetOne from "../../components/buy-one-get-one/buy-one-get-one";

Vue.use(VueSocialSharing);
Vue.use(VueHZoom);
Vue.component('originalVueZoom', VueHZoom);
const newZoom = Vue.component('originalVueZoom').extend({
  methods: {
    updateThumbnailPos: function () {
      const el = this.$refs.thumbnail;
      let elementDim = el.getBoundingClientRect();
      this.thumbnailPos = {
        top: elementDim.top,
        left: elementDim.left,
      }
    },
  }
});
export default {
  name: "productDetails",
  mixins: [toProductDetail],
  components: {
    breadcrumb,
    VueHZoom: newZoom,
    productCard,
    'buy-one-get-one': buyOneGetOne
  },
  data() {
    return {
      sharing: {
        // url: "https://afmstage-web.truckxi.com",
        url: "https://shopafm.com",
        title: "Asian Family Market!",
        description: "Food",
        quote: "quality and authenticity",
        hashtags: "AFM,food",
        twitterUser: "",
      },
      starRating: 0,
      starIndex: [],
      favorited: false,
      zoom: {
        screenWidth: 0,
        width: 0,
        height: 0,
        zoomX: 0,
        zoomY: 0,
      },
      num: 0, // number count
      review: 0,
      cartCount: 0,
      bigImg: "",
      zoomImg: "",
      isactive: 0, //click
      //review info
      reviews: false,//show rview submit
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
    }
  },
  mounted: function () {
    // this.sharing.url = 'https://afmstage-web.truckxi.com' + this.$router.currentRoute.fullPath;
    this.sharing.url = 'https://shopafm.com' + this.$router.currentRoute.fullPath;

    if (!this.isMobile) {
      return
    }
    // 手机端运行
    this.fetchProductDetails(this.activeProduct);
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
    this.initializeTabImg();
    if (isUserAuthenticated()) {
      this.findFavorites({productNum: this.activeProduct})
    }
  },
  beforeDestroy() {
    if (!this.isMobile) {
      return
    }
    // 手机端运行
    console.log('beforeDestroy');
    this.fetchProductDetails('');
    this.$store.dispatch('products/fetchProductDetails', '')
    if (isUserAuthenticated()) {
      this.favorited = false
    }
  },
  methods: {
    ...mapActions('products', ['fetchProductDetails']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    ...mapActions('products', ['addProductToFavorites', 'getFavorites', 'removeProductFromFavorites']),
    ...mapMutations('checkout', ['saveTotalPrice', 'clearPromoCode', 'clearCard']),
    ...mapMutations('navbar', ['toggleProductDetailImgVisibility', 'toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    tabImg(num) {
      this.bigImg = this.product.Images[num]; // right side big img
      this.zoomImg = this.product.Large_Images[num]; // zoom big img
      this.isactive = num; // tab the img
    },
    initializeTabImg() {
      this.bigImg = "";
      this.zoomImg = "";
      this.isactive = 0;
    },
    isOutOfStock(product) {
      if(product.IsOverSaleable) {
        return false
      }
      return product.InventoryQuantity > 0 ? false : true
    },
    updateItemCount(e, item) {
      e.preventDefault();
      let cartItems = this.loggedIn ? this.cartProductsList.Sales_Order_Lines : this.cartProductsList;
      let cartProduct = cartItems.filter(x => x.Product_id === item.Product_id)[0];
      if (isUserAuthenticated()) {
        let quantity = cartProduct.Quantity - 1;
        if (quantity < 1) {
          this.deleteItem(cartProduct);
        } else {
          this.$store.dispatch('cart/updateItemQuantity', [cartProduct.Product_id, quantity])
            .then(() => {
              this.local = false;
              this.$store.dispatch('cart/getCart');
            });
        }
      } else {
        cartProduct.quantity = cartProduct.quantity - 1;
        if (cartProduct.quantity < 1) {
          this.deleteItem(cartProduct)
        }
        this.$store.dispatch('cart/updateLocalCart', cartProduct)
          .then(() => {
            this.local = true;
            this.$store.dispatch('cart/fetchCartProducts');
          })
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    handleResize() {
      this.zoom.screenWidth = window.innerWidth;
      if (this.zoom.screenWidth > 1139) {
        this.zoom.width = 400;
        this.zoom.height = 400;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth < 1140 && this.zoom.screenWidth > 892) {
        this.zoom.width = 300;
        this.zoom.height = 300;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth < 893 && this.zoom.screenWidth > 772) {
        this.zoom.width = 278;
        this.zoom.height = 278;
        this.zoom.zoomX = 300;
        this.zoom.zoomY = 100;
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          this.$store.dispatch('cart/getCart')
        })
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    addToCart: function (item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      item.quantity = this.num + 1;
      
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
      }
    },
    // review list change
    customerList() {
      this.reviews = !this.reviews
    },
    toggleImgModalVisibility(status, img) {
      // 手机端直接返回
      if (this.isMobile) {
        return
      }
      this.toggleProductDetailImgVisibility({status, img});
    },
    onClickBrand(brand) {
      if (brand) {
        if (this.$router.currentRoute.path !== '/collections') {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewSearch(brand, 'Brand');
          }, 600);
        } else {
          this.$root.selectNewSearch(brand, 'Brand');
        }
      }
    },
    findFavorites(product) {
      this.getFavorites()
        .then((res) => {
          let favorite = res.data.find(({ProductNum}) => {
            let num = product.productNum ? product.productNum : product.ProductNum
            return num === ProductNum;
          });
          this.favorited = (typeof favorite !== 'undefined');
        })
    },
    favoriteProduct(product) {
      if (this.favorited) {
        this.removeProductFromFavorites(product.Product_id)
      } else if (!this.favorited) {
        this.addProductToFavorites(product.Product_id)
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            })
        })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cart: state => state.cart.cart,
    cartProductsList: state => state.cart.cartProductsList,
    productDetails: state => state.products.productDetails,
    itemCount: state => state.cart.itemCount,
    itemDeleted: state => state.cart.itemDeleted,
    activeQuantity: state => state.products.activeQuantity,
    groups: state => state.navbar.allGroups,
    favoriteSuccess: state => state.products.favoriteSuccess,
    favoriteLoading: state => state.products.favoriteLoading,
    loggedIn: state => state.auth.loggedIn,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    showPrice: state => state.auth.showLevel5Price,
    showInstock: state => state.auth.showInstock,
    currQuantity() {
      let currProduct = this.product.Product_id;
      let productFound = [];
      if(this.cartItems ){
        productFound = this.cartItems.filter(x => x.Product_id === currProduct);
      }
      return this.loggedIn ? productFound[0] ? productFound[0].Quantity : 0 : productFound[0] ? productFound[0].quantity : 0;
    },
    cartItems() {
      return this.loggedIn ? this.cartProductsList.Sales_Order_Lines : this.cartProductsList;
    }
  }),
  watch: {
    favoriteSuccess: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.findFavorites(this.product);
      }
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        // 手机端直接返回
        if (this.isMobile) {
          return
        }
        this.fetchProductDetails(newVal.productNum);
        this.updateActiveProduct(newVal.productNum);
        this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
        this.initializeTabImg();
        if (isUserAuthenticated()) {
          this.findFavorites(newVal)
        }

      },
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        let quantFound = false;
        //Unfortunately, because `item.quantity` is used in other places, we can't combine the authenticated and unauthenticated mapping into one function and use || to delineate between the local storage cart and api cart. --Anthony
        if (isUserAuthenticated()) {
          this.cartProductsList.Sales_Order_Lines.map(item => {
            if (item.ProductNum === this.activeProduct) {
              quantFound = true;
              this.updateActiveQuantity(item.Quantity)
            }
          })
        } else {
          this.cartProductsList.map(item => {
            if (item.ProductNum === this.activeProduct) {
              quantFound = true;
              this.updateActiveQuantity(item.quantity)
            }
          })
        }
        if (!quantFound) {
          this.updateActiveQuantity(0);
        }
      }
    },
    product(newVal, oldVal) {
      if (!newVal) {
        return
      }
      this.starIndex = [];
      if (newVal.Rating || newVal.Rating === 0) {
        for (let i = 1; i < 6; i++) {
          if (newVal.Rating >= i) {
            this.starIndex.push(star2);
          } else if (newVal.Rating > (i - 1) && newVal.Rating < i) {
            this.starIndex.push(star1);
          } else if (newVal.Rating <= (i - 1)) {
            this.starIndex.push(star0);
          }
        }
        this.starRating = newVal.Rating;
      } else {
        this.starIndex = [star0, star0, star0, star0, star0];
        this.starRating = 0;
      }
    },
    $route(to, from) {
      this.bigImg = "";
      this.zoomImg = "";
      // this.sharing.url = 'https://afmstage-web.truckxi.com' + this.$router.currentRoute.fullPath;
      this.sharing.url = 'https://shopafm.com' + this.$router.currentRoute.fullPath;
    },
  }
}
$(function () {
  $('.sp-wrap').smoothproducts();
})
</script>

<style lang="less">
@import "../../assets/css/details.less";
@import "../../assets/css/jqzoom.css";
@import "../../assets/css/navbar.less";
@import "../../assets/css/smoothproducts.css";
@import "../../assets/css/modalNew.less";
@import "../../assets/query/details.less";
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileProductDetails.vue